import React from 'react';

interface SlideNavigationProps {
  currentSlide: number;
  totalSlides: number;
  onPrevious: () => void;
  onNext: () => void;
}

export const SlideNavigation: React.FC<SlideNavigationProps> = ({
  currentSlide,
  totalSlides,
  onPrevious,
  onNext,
}) => {
  const isFirstSlide = currentSlide === 0;
  const isLastSlide = currentSlide === totalSlides - 1;

  return (
    <div className="flex items-center justify-center gap-4 py-3">
      {/* Previous button */}
      <button
        onClick={onPrevious}
        disabled={isFirstSlide}
        className={`px-4 py-2 rounded transition-colors ${
          isFirstSlide
            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
            : 'bg-[#730D0E] text-white hover:bg-[#730D0E]/90'
        }`}
        aria-label="Previous slide"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {/* Slide counter */}
      <div className="text-lg font-semibold min-w-[80px] text-center">
        {currentSlide + 1} / {totalSlides}
      </div>

      {/* Next button */}
      <button
        onClick={onNext}
        disabled={isLastSlide}
        className={`px-4 py-2 rounded transition-colors ${
          isLastSlide
            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
            : 'bg-[#730D0E] text-white hover:bg-[#730D0E]/90'
        }`}
        aria-label="Next slide"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
  );
};
